module.exports = __webpack_public_path__ + "static/checkout-41065f11aa3493547caa64570510fd13.png";